// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1HourProjectSchema = z.object({
  id: z.number().int().describe("Unique identifier for the project"),
  active: z.boolean().describe("Whether the project is active"),
  account_id: z.number().int().describe("Account ID that owns the project"),
  name: z.coerce.string().describe("Name of the project"),
  description: z.nullable(z.coerce.string().describe("Project description")),
  color: z.coerce.string().describe("Hex color code for the project"),
  rate_type: z.coerce.string().describe("Rate type for billing (e.g., hourly, fixed)"),
  billable: z.boolean().describe("Whether the project is billable"),
  created_at: z.number().int().describe("Unix timestamp when the project was created"),
  updated_at: z.number().int().describe("Unix timestamp when the project was last updated"),
  external_id: z.coerce.string().describe("External ID for mapping with external systems").nullish(),
  budget_scope: z.coerce.string().describe("Scope of the budget (e.g., project, phase)").nullish(),
  client: z.object({
    id: z.number().int().describe("Unique identifier for the client"),
    name: z.coerce.string().describe("Name of the client"),
    color: z.coerce.string().describe("Hex color code for the client"),
    active: z.boolean().describe("Whether the client is active"),
    external_id: z.coerce.string().describe("External ID for the client").nullish(),
    updated_at: z.string().datetime().describe("ISO8601 timestamp when the client was last updated"),
  }).describe("Client associated with the project"),
  required_notes: z.boolean().describe("Whether notes are required for time entries"),
  required_labels: z.boolean().describe("Whether labels are required for time entries"),
  budget_expired_on: z.coerce.string().describe("Date when the budget expires (ISO 8601 format)").nullish(),
  has_recurrence: z.boolean().describe("Whether the project has recurring budget"),
  enable_labels: z.coerce.string().describe("Label enablement setting (e.g., enabled, disabled, inherited)"),
  default_labels: z.boolean().describe("Whether default labels are applied"),
  allow_only_one_tag: z.boolean().describe("Whether only one tag is allowed per time entry"),
  currency: z.object({
    id: z.coerce.string().describe("Currency identifier"),
    name: z.coerce.string().describe("Currency name"),
    iso_code: z.coerce.string().describe("ISO 4217 currency code"),
    symbol: z.coerce.string().describe("Currency symbol"),
    symbol_first: z.boolean().describe("Whether to display symbol before the amount"),
  }).describe("Currency for the project"),
  team_ids: z.array(z.number().int()).describe("Array of team IDs associated with the project"),
  budget: z.number().int().describe("Budget amount in cents").nullish(),
  budget_type: z.coerce.string().describe("Type of budget (e.g., hours, money)").nullish(),
  budget_calculation: z.coerce.string().describe("Method for calculating budget").nullish(),
  hour_rate: z.number().describe("Hourly rate for the project").nullish(),
  hour_rate_in_cents: z.number().describe("Hourly rate in cents").nullish(),
  budget_progress: z.number().describe("Budget progress as a decimal (0.0 to 1.0)").nullish(),
  budget_percent: z.number().describe("Budget percentage used").nullish(),
  invoice_by_budget: z.boolean().describe("Whether to invoice by budget").nullish(),
  labels: z.array(z.object({
    id: z.number().int(),
    name: z.coerce.string(),
    sequence: z.number().int(),
    parent_id: z.number().int().nullish(),
    emoji: z.coerce.string().nullish(),
    active: z.boolean(),
    external_id: z.coerce.string().nullish(),
    created_at: z.string().datetime().nullish(),
    updated_at: z.string().datetime().nullish(),
    tic: z.optional(z.object({
      uri: z.coerce.string(),
      tool_id: z.coerce.string().nullish(),
      external_url: z.coerce.string().nullish(),
    })),
    children: z.optional(z.array(z.unknown())),
  })).describe("Array of label objects associated with the project"),
  label_ids: z.array(z.number().int()).describe("Array of label IDs associated with the project"),
  required_label_ids: z.array(z.number().int()).describe("Array of required label IDs"),
  default_label_ids: z.array(z.number().int()).describe("Array of default label IDs"),
  created_from: z.coerce.string().describe("Source from which the project was created"),
  cost: z.optional(z.object({
    fractional: z.optional(z.number().int()),
    formatted: z.optional(z.coerce.string().min(1)),
    amount: z.optional(z.number()),
    currency_code: z.optional(z.coerce.string().min(1)),
  }).describe("Total cost for the project in this hour entry")),
  estimated_cost: z.optional(z.object({
    fractional: z.optional(z.number().int()),
    formatted: z.optional(z.coerce.string().min(1)),
    amount: z.optional(z.number()),
    currency_code: z.optional(z.coerce.string().min(1)),
  }).describe("Estimated cost for the project")),
  billed_cost: z.optional(z.object({
    fractional: z.optional(z.number().int()),
    formatted: z.optional(z.coerce.string().min(1)),
    amount: z.optional(z.number()),
    currency_code: z.optional(z.coerce.string().min(1)),
  }).describe("Billed cost for the project")),
  unbilled_cost: z.optional(z.object({
    fractional: z.optional(z.number().int()),
    formatted: z.optional(z.coerce.string().min(1)),
    amount: z.optional(z.number()),
    currency_code: z.optional(z.coerce.string().min(1)),
  }).describe("Unbilled cost for the project")),
  duration: z.optional(z.object({
    hours: z.optional(z.number().int()),
    minutes: z.optional(z.number().int()),
    seconds: z.optional(z.number().int()),
    formatted: z.optional(z.coerce.string().min(1)),
    total_hours: z.optional(z.number()),
    total_seconds: z.optional(z.number().int()),
    total_minutes: z.optional(z.number().int()),
  }).describe("Total duration for the project in this hour entry")),
  estimated_duration: z.optional(z.object({
    hours: z.optional(z.number().int()),
    minutes: z.optional(z.number().int()),
    seconds: z.optional(z.number().int()),
    formatted: z.optional(z.coerce.string().min(1)),
    total_hours: z.optional(z.number()),
    total_seconds: z.optional(z.number().int()),
    total_minutes: z.optional(z.number().int()),
  }).describe("Estimated duration for the project")),
  billed_duration: z.optional(z.object({
    hours: z.optional(z.number().int()),
    minutes: z.optional(z.number().int()),
    seconds: z.optional(z.number().int()),
    formatted: z.optional(z.coerce.string().min(1)),
    total_hours: z.optional(z.number()),
    total_seconds: z.optional(z.number().int()),
    total_minutes: z.optional(z.number().int()),
  }).describe("Billed duration for the project")),
  unbilled_duration: z.optional(z.object({
    hours: z.optional(z.number().int()),
    minutes: z.optional(z.number().int()),
    seconds: z.optional(z.number().int()),
    formatted: z.optional(z.coerce.string().min(1)),
    total_hours: z.optional(z.number()),
    total_seconds: z.optional(z.number().int()),
    total_minutes: z.optional(z.number().int()),
  }).describe("Unbilled duration for the project")),
});
